import { render, staticRenderFns } from "./AGlassChamferSelector.vue?vue&type=template&id=9ad49b4a&"
import script from "./AGlassChamferSelector.vue?vue&type=script&lang=js&"
export * from "./AGlassChamferSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports